import assetsRouterPaths from './assetsRouterPaths';

export default assetsRouterPaths;
